import React from 'react';
import SVG from "react-inlinesvg";
import { Modal } from "react-bootstrap";
import { NavLink } from 'react-router-dom';
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";
import { formatAmount } from '../../../../../../util/Helpers';
import ErrorMessage from './ErrorMessage';


const CreateWithdrawal = ({show, action: {action, error, actedOn, data}, onHide}) => {

    return <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header >
              <Modal.Title id="contained-modal-title-vcenter">
                <span className={`svg-icon svg-icon-lg svg-icon-primary mr-3`}>
                    <SVG
                        title=""
                        src={toAbsoluteUrl("/media/svg/icons/Shopping/Wallet3.svg")}
                    />
                </span> {action}
              </Modal.Title>
              <button type="button" className="close" onClick={onHide}>
                  <span aria-hidden="true" className="d-block">×</span>
                  <span className="sr-only">Close</span>
               </button>
            </Modal.Header>
            <Modal.Body>
                <ErrorMessage {...{error}} />
                <div className="px-md-5">
                    <div className="row">
                        <div className="col-md-4 h6">
                            User
                        </div>
                        <div className="col-md h6 text-muted">
                            <NavLink to={`/users/view/${data?.userId}`} target="_blank" >
                                {`${data.meta?.firstName ?? ""} ${data.meta?.lastName ?? ""}`}
                            </NavLink>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Email
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.meta?.email}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Account Id
                        </div>
                        <div className="col-md h6 text-muted">
                            <NavLink to={`/users/view/${data?.userId}/account-information/${data?.accountId}`} className="text-muted text-hover-primary" target="_blank" >
                                {data?.accountId}
                            </NavLink>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Channel
                        </div>
                        <div className="col-md h6 text-muted">
                            {data.channel}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Bank Account
                        </div>
                        <div className="col-md h6 text-muted">
                            {`${data.meta.bankAccount?.bankName} ***${data.meta.bankAccount?.accountNumber?.substr(-4)} - ${data.meta.bankAccount?.currency}`}
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-4 h6">
                            Amount
                        </div>
                        <div className="col-md h6 text-muted">
                            {formatAmount(data.meta?.currency, data.amount)}
                        </div>
                    </div>
                </div>    
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-primary btn-elevate px-5"
                >
                    Okay
                </button>
            </Modal.Footer>
          </Modal>
}

export default CreateWithdrawal;